'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('./compose');

var ADD_RATING_EVENT = 'bc.addRating';
var EDIT_RATING_EVENT = 'bc.editRating';
var REMOVE_RATING_EVENT = 'bc.removeRating';
var ADD_RATING_ACTION = 'v2-add';
var EDIT_RATING_ACTION = 'v2-edit';
var REMOVE_RATING_ACTION = 'v2-remove';
var RATINGS_GTM_CATEGORY = 'v2-ratings';

/**
 * @param {string} ratingValue rating is based out of 10/100; ie 10, 30, 70 are valid values
 */
function composeRatingEvent(eventName, ratingValue, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: ratingValue,
    gtmCategory: RATINGS_GTM_CATEGORY,
    gtmAction: action
  });
}

function composeAddRatingEvent(ratingValue) {
  return (0, _compose.composeAnalytics)([composeRatingEvent(ADD_RATING_EVENT, ratingValue, ADD_RATING_ACTION)]);
}

function composeEditRatingEvent(ratingValue) {
  return (0, _compose.composeAnalytics)([composeRatingEvent(EDIT_RATING_EVENT, ratingValue, EDIT_RATING_ACTION)]);
}

function composeRemoveRatingEvent() {
  return (0, _compose.composeAnalytics)([composeRatingEvent(REMOVE_RATING_EVENT, undefined, REMOVE_RATING_ACTION)]);
}

exports.default = {
  composeAddRatingEvent: composeAddRatingEvent,
  composeEditRatingEvent: composeEditRatingEvent,
  composeRemoveRatingEvent: composeRemoveRatingEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/ratingsEventComposer.js
// module id = 996
// module chunks = 1